import React from "react";

type YellowLogo = {
  yellowLogoPosition: number;
  className?: string;
};

export default function SPYellowLogo({
  yellowLogoPosition,
  className,
}: YellowLogo) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`text--carousel__options-logo ${className}`}
      style={{ top: `${yellowLogoPosition}px` }}
    >
      <path
        d="M11.7826 1.16437C9.11455 2.61205 7.63898 5.57522 9.10894 9.36305C10.4648 12.8567 13.6146 16.9575 13.6568 17.0001L1.12888 9.65996C0.795582 9.46474 0.366956 9.62283 0.240416 9.99149C-0.697784 12.7231 1.16252 16.6532 4.9024 18.8444C5.61605 19.2625 6.37358 19.5913 7.14379 19.8299C10.7971 20.9613 14.7082 19.1304 16.2812 15.5982L20.5807 5.94438C21.1388 4.68746 21.1597 3.22121 20.5229 2.00882C19.071 -0.752686 15.3226 -0.0539536 13.3055 0.546794C12.7615 0.708858 12.2449 0.914962 11.7824 1.16437H11.7826Z"
        fill="#FFC600"
      />
    </svg>
  );
}
